import {
  SubscriptionStatus,
  UserType,
} from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';
import { ESubscriptionActivity } from '@leedpulse-monorepo/enums';
import { TPartnerSystemFilter } from '../../../presentation/components/subscriptions_page/ExportSubscriptionsStatsModal';

export interface ExportSubscriptionsStatsResult {
  url: string;
  filename: string;
}

export const exportSubscriptionsStats = async (
  subscriptionStatus: SubscriptionStatus[],
  partner_systems: TPartnerSystemFilter[],
  userType: UserType[],
  planIds: string[],
  activities: ESubscriptionActivity[],
  auth: Authentication
): Promise<ExportSubscriptionsStatsResult> => {
  try {
    const { blob, filename } = await HttpClient.postBlob(
      '/subscription/stats/export',
      {
        status: subscriptionStatus,
        partner_systems,
        user_types: userType,
        plan_ids: planIds,
        activities,
      },
      auth.token
    );

    // Create a downloadable URL from the blob
    const url = URL.createObjectURL(blob);

    return { url, filename };
  } catch (error) {
    console.error("❌ Erreur lors de l'export des stats :", error);
    throw error;
  }
};
